/**
 * Whether the browser is built on WebKit: Safari on the Mac and on the
 * iPhone, and every browser on iPhone and iPad. The vendor tells it where
 * the user agent does not (Playwright gives WebKit a Chrome user agent).
 */
export function isWebKitBrowser() {
    return (typeof navigator !== 'undefined' &&
        /Apple Computer/.test(navigator.vendor ?? ''));
}
